import axiosService from './axiosService';

class PasswordService {
  // Change the password of the current logged in user.
  changePassword = (username, currentPassword, newPassword) => axiosService.put(
    '/api/passwords/change',
    {
      username,
      currentPassword,
      newPassword
    }
  );

  // Send an email with a link to reset a forgotten password.
  sendResetPasswordEmail = (username) => axiosService.post(
    '/api/passwords/send',
    {
      username
    }
  );

  // Send a request to reset user's forgotten password from the emailed link.
  resetForgottenPassword = (username, password, emailToken) => axiosService.post(
    '/api/passwords/reset',
    {
      username,
      password,
      emailToken
    }
  );
}

const passwordService = new PasswordService();
export default passwordService;
